import vari from '@/app/shared/utils/variables'
import axios from 'axios'
import format from '@/app/shared/utils/format'
import SimpleCrypto from 'simple-crypto-js'

const crypt_key = process.env.VUE_APP_CRYPT_KEY
const simpleCrypto = new SimpleCrypto(crypt_key)
const actions = {
  async getAllTicketsToManage(
    context,
    {
      idMailbox,
      search,
      page,
      dateRange,
      status,
      read,
      line,
      channel,
      tags,
      order,
      customFields,
      favorite,
      ticketStatuses,
      clientsId,
      agent,
      products,
      strategies,
      channelCompanyId = 'all',
    }
  ) {
    try {
      const response = await axios.post(`${vari.UHR}/admin/tickets/searches`, {
        idMailbox,
        search,
        page,
        dateRange: dateRange && dateRange.length > 0 ? dateRange : null,
        status,
        read,
        line,
        channel,
        tags,
        order,
        customFields,
        favorite,
        ticketStatuses,
        clientsId,
        agent,
        products,
        strategies,
        channelCompanyId,
      })
      context.commit('SET_TICKETS_TO_MANAGE', response.data)
    } catch (error) {
      console.error('getAllTicketsToManage', error)
    }
  },
  updateAgentInTicketsToManage(context, { agent, ticket, tickets }) {
    try {
      if (ticket) {
        context.getters.ticketsToManage.data.forEach((ticketStore, index) => {
          if (ticketStore._id == ticket._id) {
            context.commit('SET_AGENT_IN_TICKET_TO_MANAGE', { agent, index })
          }
        })
      } else {
        console.log(tickets)
      }
    } catch (error) {
      console.error('updateAgentInTicketsToManage', error)
    }
  },
  updateStatusInTicketsToManage(
    context,
    { status, subStatus, ticket, tickets }
  ) {
    try {
      if (ticket) {
        context.getters.ticketsToManage.data.forEach((ticketStore, index) => {
          if (ticketStore._id == ticket._id) {
            context.commit('SET_STATUS_IN_TICKET_TO_MANAGE', {
              status,
              subStatus,
              index,
              pendings: ticket.pendings,
            })
            context.commit('SET_USERS_IN_TICKET_TO_MANAGE', {
              users: ticket.users,
              index,
            })
          }
        })
      } else {
        tickets.forEach((ticket) => {
          const index = context.getters.ticketsToManage.data.findIndex(
            (savedTicket) => savedTicket._id == ticket._id
          )
          context.commit('SET_STATUS_IN_TICKET_TO_MANAGE', {
            status,
            subStatus,
            index,
            pendings: ticket.pendings,
          })

          context.commit('SET_USERS_IN_TICKET_TO_MANAGE', {
            users: ticket.users,
            index,
          })
        })
      }
    } catch (error) {
      console.error('updateStatusInTicketsToManage', error)
    }
  },
  updateTagsInTicketsToManage(context, { ticket }) {
    try {
      const index = context.getters.ticketsToManage.data.findIndex(
        (savedTicket) => savedTicket._id == ticket._id
      )
      context.commit('SET_TAGS_IN_TICKET_TO_MANAGE', {
        tags: ticket.settings.tags,
        index,
      })
    } catch (error) {
      console.error('updateTagsInTicketsToManage', error)
    }
  },
  updateLineInTicketsToManage(context, { ticket, line, agent }) {
    try {
      const index = context.getters.ticketsToManage.data.findIndex(
        (savedTicket) => savedTicket._id == ticket._id
      )
      context.commit('SET_LINE_IN_TICKET_TO_MANAGE', {
        line,
        index,
      })
      context.commit('SET_STATUS_IN_TICKET_TO_MANAGE', {
        status: ticket.status,
        subStatus: ticket.subStatus,
        index,
        pendings: ticket.pendings,
      })
      context.commit('SET_AGENT_IN_TICKET_TO_MANAGE', { agent, index })
      context.commit('SET_USERS_IN_TICKET_TO_MANAGE', {
        users: ticket.users,
        index,
      })
    } catch (error) {
      console.error('updateLineInTicketsToManage', error)
    }
  },

  updateStoredTicket(context, ticket) {
    try {
      const index = context.getters.ticketsToManage.data.findIndex(
        (savedTicket) => savedTicket._id == ticket._id
      )
      context.commit('UPDATE_STORED_TICKET', {
        ticket,
        index,
      })
    } catch (error) {
      console.error('updateStoredTicket', error)
    }
  },
  /**
   * Exporta en excel los tickets
   * @param {*}       context
   * @param {Object} args
   * @param {String} args.search
   * @param {String} args.channel
   * @param {String[]} args.dateRange
   */
  exportTickets(context, { filters, headers }) {
    let response = null
    const token = format.fixedEncodeURIComp(context.getters.token)
    const filtersEncrypt = format.fixedEncodeURIComp(
      simpleCrypto.encrypt(filters)
    )
    const headersEncrypt = format.fixedEncodeURIComp(
      simpleCrypto.encrypt(headers)
    )
    const url = `${
      vari.UHM
    }/export/tickets?filters=${filtersEncrypt}&headers=${headersEncrypt}&token=${token}&timezoneOffset=${new Date().getTimezoneOffset()}`
    response = window.open(url)
    return response
  },
  /**
   * Obtiene los productos asignados a un ticket sin paginacion
   * @param {String} idTicket
   */
  async getAssignedProductsNoPagedOfTicket(context, idTicket) {
    try {
      const response = await axios.get(
        `${vari.UHR}/agent/ticket/${idTicket}/products-crm`
      )
      if (response.data.success) {
        const assignedProducts = response.data.result.map(
          (item) => item.product
        )
        return { success: true, result: assignedProducts }
      } else return response.data.result
    } catch (err) {
      console.error('getAssignedProductsNoPagedOfTicket', err)
      return err.response?.data
    }
  },
  /**
   * Obtiene las campañas de la empresa con una paginacion maxima de 200
   * @return {Object[]} - array de estrategias
   * @return {String} - strategy[].name
   * @return {String} - strategy[].status
   * @return {String} - strategy[]._id
   * @return {Date} - strategy[].created_at
   * @return {Date} - strategy[].updated_at
   */
  async getStrategiesNoPaged() {
    try {
      const response = await axios.get(`${vari.UHR}/strategies/list/crm`)
      if (response.data.success) {
        return response.data
      } else return []
    } catch (err) {
      console.error('[getStrategiesNoPaged]', err)
      return err.response?.data
    }
  },
}

export default actions
